import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { SharedService } from '../../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  loginForm: FormGroup;
  isLoading = false;
  errorMessage: string | null = null;
  shareObject: any = null;
  constructor(
    private fb: FormBuilder,
    private shareService: SharedService,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      staySignedIn: [false]
    });

    if (this.shareService.token && this.shareService.token.length > 0) {
      this.router.navigate(['/user/profile']);
      return;
    }
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }
    this.isLoading = true;
    this.errorMessage = null;

    const { email, password, staySignedIn } = this.loginForm.value;
    this.shareService.login(email, password, staySignedIn).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.router.navigate(['/user/profile']);
      },
      error: (err: any) => {
        this.isLoading = false;
      }
    });
  }
}
